import { useTranslation } from 'react-i18next';
import Button from '../../components/Button/Button';
import Text from '../../components/Text/Text';
import Icon from '../../components/Icon/Icon';
import { VerticalSpaced } from '../../components/Spaced/Spaced';
import { Row } from '../../components/Grid/Grid';
import { useStyles } from './styles';
import useBack from './useBack';
import AppLoading from './AppLoading';
import BackTextLoading from './BackLoading';

export function BackTextButton() {
  const { t } = useTranslation();
  const goBackToCheckout = useBack();
  const classes = useStyles();

  return (
    <VerticalSpaced size="medium">
      <Row>
        <AppLoading loadingComponent={<BackTextLoading />}>
          <Button data-testid="textBackButton" type="textSecondary" onClick={goBackToCheckout}>
            <Row>
              <Text type="secondaryLink">{t('backToCheckout')}</Text>
              <Icon name="external" className={classes.externalIcon} />
            </Row>
          </Button>
        </AppLoading>
      </Row>
    </VerticalSpaced>
  );
}

export function BackIconButton() {
  const classes = useStyles();
  const goBackToCheckout = useBack();

  return (
    <Button data-testid="iconBackButton" type="icon" onClick={goBackToCheckout}>
      <Icon name="angleLeft" className={classes.backIcon} />
    </Button>
  );
}
